<template>
  <v-container>
    <v-row justify="center">
      <v-col md="6" sm="7" xs="12">
        <v-card>
          <v-form ref="form">
            <v-card-title>
              <h3>Production Manager Sign Up</h3>
            </v-card-title>

            <v-card-text>

            <v-row wrap>
              <v-col
                cols="6"
                sm="6"
              >
                <v-text-field
                  label="First Name"
                  v-model="firstName"
                  :rules="[rules.required]"
                  name="firstName"
                ></v-text-field>
              </v-col>
              <v-col
                cols="6"
                sm="6"
              >
                <v-text-field
                  label="Last Name"
                  v-model="lastName"
                  :rules="[rules.required]"
                  name="lastName"
                ></v-text-field>
              </v-col>
            </v-row>
                <v-text-field
                  label="Email"
                  v-model="email"
                  :rules="[rules.required]"
                  name="email"
                ></v-text-field>

                <v-text-field
                  label="Confirm Email"
                  v-model="confirmEmail"
                  :rules="[rules.required]"
                  name="confirmEmail"
                ></v-text-field>

                <v-text-field
                  label="Password"
                  v-model="password"
                  :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                  :rules="[rules.required, rules.min]"
                  :type="show1 ? 'text' : 'password'"
                  name="password"
                  hint="At least 8 characters"
                  counter
                  @click:append="show1 = !show1"
                ></v-text-field>
                <v-text-field
                  label="Confirm New Password"
                  v-model="confirmPassword"
                  :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                  :rules="[rules.required, rules.min]"
                  :type="show2 ? 'text' : 'password'"
                  name="confirmPassword"
                  hint="At least 8 characters"
                  counter
                  @click:append="show2 = !show2"
                ></v-text-field>
            </v-card-text>
            <v-card-actions style="padding-bottom:15px">

              <v-row justify="center">
                  <v-btn
                    color="primary"
                    @click="createUser()"
                  >
                    Submit
                  </v-btn>
              </v-row>

            </v-card-actions>
    
          </v-form>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>


<script>
import { getActiveUsers } from '../services/users';
import { userRegister } from '../services/users';

export default {
  components: {
  },
  data() {
    return {
      rules: {
          required: value => !!value || 'Required.',
          min: v => v.length >= 8 || 'Min 8 characters',
          emailMatch: () => (`The emails you entered don't match`),
          passwordMatch: () => (`The passwords you entered don't match`),
      },
      show1: false,
      show2: false,
      firstName: '',
      lastName: '',
      email: '',
      confirmEmail: '',
      password: '',
      confirmPassword: '',
      allUsers: '',
    };
  },
  async mounted() {
    // This gets all of the usernames and emails
    await this.getData();
  },
  methods: {
    async getData() {
      // Gets all the active users usernames and emails
      this.loading = true;
    },
    async createUser(){
      if (!this.$refs.form.validate()) {
        return;
      }
      
      let user = {
        'email': this.email,
        'password': this.password,
        'firstName': this.firstName,
        'lastName': this.lastName,
        'username': this.email,
      }
      if (this.password != this.confirmPassword){
        this.$emit('snackbar', { text: 'Passwords do not match', color: 'red' });
        return
      }
      if (this.email != this.confirmEmail){
        this.$emit('snackbar', { text: 'Emails do not match', color: 'red' });
        return
      }
      try {
        // Creates the user
        await userRegister(user);
        // After successfully creating the user sends them to a success page
        this.$router.push({ name: 'sign-up-form-success' });
      } catch (e) {
        if (e.response.status === 502) {
          this.$emit('snackbar', { text: '502 Bad Gateway', color: 'red' });
        } else if (e.response.status === 400) {
          this.$emit('snackbar', { text: 'Email has already been taken.', color: 'red' });
        }
        else {
          this.$emit('snackbar', { text: 'Unable to create profile.', color: 'red' });
        }
      }
    }
  },
};
</script>